import { useSuspenseQuery } from '@apollo/client';
import { GetWorkspaceDocument } from '__generated__/graphql';
import { useParams } from 'react-router';

export function useWorkspace(slug: string) {
  const {
    data: { contentfulWorkspaceCollection },
  } = useSuspenseQuery(GetWorkspaceDocument, {
    variables: {
      slug,
    },
  });

  return contentfulWorkspaceCollection?.items[0];
}

export function useWorkspacePath(slug?: string) {
  const params = useParams();
  const workspaceSlug = slug || params.workspaceSlug;
  return workspacePath(workspaceSlug);
}

export function workspacePath(slug?: string) {
  return slug ? `/workspaces/${slug}` : '';
}
